import type {ReactElement} from 'react';
import React from 'react';
import {BasePosterEditingFontOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-poster-editing-font-option';
import {ContextualMenuFontButton} from '@Components/contextual-menu/components/contextual-menu-font-button';
import {isFontSupported} from '@Libraries/font-library';
import {useGetSelectedTranscriptItem} from '@Hooks/poster-editor/useGetSelectedTranscriptItem';
import {useAppSelector} from '@/hooks';
import type {TranscriptFontOptionProps} from './transcript-font-option.types';
import {useGetKeyFromSubtitleTextStylesForTranscriptItem} from '@Hooks/poster-editor/useGetKeyFromSubtitleTextStylesForTranscriptItem';

export function TranscriptFontOption({...props}: TranscriptFontOptionProps): ReactElement<any> {
  const activeItem = useGetSelectedTranscriptItem();
  if (activeItem === null) {
    throw new Error('Transcript Item is undefined in TranscriptFontOption');
  }

  const areFontsLoading = useAppSelector((state) => {
    return state.fontSelector.areFontsLoading;
  });

  const fontFamily = useGetKeyFromSubtitleTextStylesForTranscriptItem('fontFamily', false);
  if (!fontFamily) {
    throw new Error('Transcript item does not have font family attribute in sentenceTextStyles');
  }

  const onClickHandler = (): void => {
    props.onClickFontButton();
  };

  return (
    <BasePosterEditingFontOption>
      <ContextualMenuFontButton
        id="item-font-option"
        label={window.i18next.t('pmwjs_font')}
        selectedFontFamily={fontFamily}
        onClickFontButton={onClickHandler}
        isFontSuppported={isFontSupported(fontFamily) && !areFontsLoading}
      />
    </BasePosterEditingFontOption>
  );
}
